/* 
    Тип интервала для значений виджета Детектор ударов
*/
export enum HitDetectorWidgetIntervalType {
  Days = 'days',
  Hours = 'hours',
}

/* 
    Тип интервала для значений виджета Общая информация узла
*/
export enum NodeSummaryWidgetIntervalType {
  Day = 'days',
  Week = 'weeks',
  Month = 'months',
}
